// 数据海报 平台
import DataPosterFull from '@containers/platfrom_dataPoster/dataPosterFull.vue'

// 海报库
const PosterLibraryIndex = () =>
  import(
    /* webpackChunkName: "PosterLibraryIndex" */ '@dataPosterPlatfrom/posterLibrary/index.vue'
  )

// 编辑工作站
const WorkstationIndex = () =>
  import(
    /* webpackChunkName: "WorkstationIndex" */ '@dataPosterPlatfrom/workstation/index.vue'
  )

// 我的工作
const MyPortfolioIndex = () =>
  import(
    /* webpackChunkName: "MyPortfolioIndex" */ '@dataPosterPlatfrom/myPortfolio/index.vue'
  )

const dataPoster_default_RouterMode = {
  path: '/dataPoster', //数据海报
  name: 'platfromDataPosterFull',
  redirect: { name: 'posterLibraryIndex' },
  component: DataPosterFull,
  children: [
    {
      path: 'posterLibrary', //海报库
      name: 'posterLibraryIndex',
      component: PosterLibraryIndex,
      meta: {
        pathModule: ['dataPoster', 'default', 'posterLibrary'],
        requireLogin: false,
        title: '海报库',
      },
    },
    {
      path: 'workstation', //海报库 -> 编辑工作站
      name: 'workstationIndex',
      component: WorkstationIndex,
      meta: {
        pathModule: ['dataPoster', 'default', 'posterLibrary'],
        requireLogin: false,
        title: '编辑工作站',
      },
    },
    {
      path: 'myPortfolio', //我的工作
      name: 'myPortfolioIndex',
      component: MyPortfolioIndex,
      meta: {
        pathModule: ['dataPoster', 'default', 'myPortfolio'],
        requireLogin: false,
        title: '我的工作',
      },
    },
    // {
    //   path: 'broadcastList', //播出单
    //   name: 'badmintonBroadcastListIndex_thomasAndUber',
    //   component: BadmintonBroadcastListIndex,
    //   meta: {
    //     pathModule: ['badminton', 'thomasAndUber', 'broadcastList'],
    //     requireLogin: false,
    //     title: '播出单',
    //   },
    // },
    // {
    //   path: 'dataPackagList', //数据包装
    //   name: 'badmintonDataPackagListIndex_thomasAndUber',
    //   component: BadmintonDataPackagListIndex,
    //   meta: {
    //     pathModule: ['badminton', 'thomasAndUber', 'dataPackagList'],
    //     requireLogin: false,
    //     title: '数据包装',
    //   },
    // },
    // {
    //   path: 'programList', //节目单
    //   name: 'badmintonProgramListIndex_thomasAndUber',
    //   component: BadmintonProgramListIndex,
    //   meta: {
    //     pathModule: ['badminton', 'thomasAndUber', 'programList'],
    //     requireLogin: false,
    //     title: '节目单',
    //   },
    // },
  ],
}

export default { dataPoster_default_RouterMode }
